export class ProductGrid {
  constructor() {
    this.products = document.querySelector("section.collection .products");
    this.distance = 1;
    this.factor = 0.05;

    if (this.products) {
      this.screenHeight = (window.innerHeight > 0) ? window.innerHeight : screen.height;
      // Compute the first obtained distance to be a base of future transition
      // so if the user refresh the page in the middle of the grid, it won't
      // suddenly pop on first scroll
      this.base = this.screenHeight - this.products.getBoundingClientRect().top;

      window.addEventListener("scroll", this.throttle(this.parallax.bind(this), 50));
    }
  }

  throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn()
        time = Date.now()
      }
    }
  }

  parallax() {
    let screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    this.screenHeight = (window.innerHeight > 0) ? window.innerHeight : screen.height;

    // distance of products grid from bottom of screen
    this.distance = this.screenHeight - this.products.getBoundingClientRect().top;

    if (screenWidth > 1300) { // 3 columns
      this.apply_animation_on('.product_item:nth-child(3n+2)', this.animation.bind(this))
    }
    else if (screenWidth > 1000) { // 2 columns
      this.apply_animation_on('.product_item:nth-child(2n+2)', this.animation.bind(this))
    }
  }

  apply_animation_on(selector, fn) {
    let toDown = this.products.querySelectorAll(selector);
    let others = [].slice.call(this.products.children).filter(n => ![].slice.call(toDown).includes(n))
    toDown.forEach((item) => fn(item));
    others.forEach((item) => fn(item, '-'));
  }

  animation(item, sign = '') {
    // Only applies effects when grid is visible, so when distance is positive
    if (this.distance > 0) {
      let coords = sign + ((this.distance - this.base) * this.factor) + 'px';
      item.style.transform = 'translateY(' + coords + ')';
      item.style.transition = 'translateY 0s';
    }
    else {
       // Updates Base to start on the next scroll down
       this.base = this.screenHeight - this.products.getBoundingClientRect().top
    }
  }
}



// WEBPACK FOOTER //
// ./js/util/productGrid.js